const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  visitedViews: state => state.tagsView.visitedViews
};
export default getters;
